import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import * as R from 'ramda'

import MenuItem from 'material-ui/MenuItem';

import Combobox from 'components/Combobox'

import dataActions from 'actions/dataActions'

import { doc, dirtyRead } from '../selectors/common'
import { agents } from '../selectors/entities'

import { sortSev } from 'utils/stuff'

let select = dirtyRead(
	(state, props) => ({
		object: doc(state, props.objectID)
	  , agents: agents(state)
	})
)

export class AgentCombobox extends Component{
	render(){
		let { props } = this
		return(
			<Combobox
				icon={
					<svg
						width="24px"
						height="24px"
						viewBox="0 0 48 48"
						version="1.1"
						xmlns="http://www.w3.org/2000/svg"
						xmlnsXlink="http://www.w3.org/1999/xlink"
						style={{
							height: "22px"
						  , display: ""
						  , position: "relative"
						  , top: "-2px"
						  , left :"-2px"
						  , marginRight: "-5px"
						  }}
					>
						<title>agent</title>
						<desc>Created with Sketch.</desc>
						<defs></defs>
						<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
							<g id="agent" fill="#56d7b7">
								<g id="Group">
									<path d="M43.1,39 L28,39 C27.4,39 27,38.6 27,38 C27,37.4 27.4,37 28,37 L42.1,37 L42.1,14.6 L16.8,14.6 L16.8,15.8 C16.8,16.4 16.4,16.8 15.8,16.8 C15.2,16.8 14.8,16.4 14.8,15.8 L14.8,13.6 C14.8,13 15.2,12.6 15.8,12.6 L43.1,12.6 C43.7,12.6 44.1,13 44.1,13.6 L44.1,38 C44.1,38.6 43.7,39 43.1,39 L43.1,39 Z" id="Shape"></path>
									<path d="M47,14.6 L47,14.6 L11.9,14.6 C11.6,14.6 11.2,14.4 11.1,14.1 C10.9,13.8 10.9,13.5 11,13.1 L15,4.2 C15.2,3.8 15.5,3.6 15.9,3.6 L42.9,3.6 C43.3,3.6 43.6,3.8 43.8,4.2 L47.8,12.9 C47.9,13.1 48,13.3 48,13.5 C48,14.2 47.6,14.6 47,14.6 L47,14.6 Z M13.4,12.6 L45.4,12.6 L42.2,5.7 L16.5,5.7 L13.4,12.6 L13.4,12.6 Z" id="Shape"></path>
									<path d="M38.1,5.7 L34.5,5.7 C33.9,5.7 33.5,5.3 33.5,4.7 L33.5,1 C33.5,0.4 33.9,0 34.5,0 L38.1,0 C38.7,0 39.1,0.4 39.1,1 L39.1,4.7 C39.1,5.3 38.7,5.7 38.1,5.7 L38.1,5.7 Z M35.5,3.7 L37.1,3.7 L37.1,2 L35.5,2 L35.5,3.7 L35.5,3.7 Z" id="Shape"></path>
									<path d="M38.1,31.1 L32,31.1 C31.4,31.1 31,30.7 31,30.1 L31,22.1 C31,21.5 31.4,21.1 32,21.1 L38.1,21.1 C38.7,21.1 39.1,21.5 39.1,22.1 L39.1,30.1 C39.1,30.7 38.7,31.1 38.1,31.1 L38.1,31.1 Z M33,29.1 L37.1,29.1 L37.1,23.1 L33,23.1 L33,29.1 L33,29.1 Z" id="Shape"></path>
									<g transform="translate(0.000000, 15.000000)" id="Shape">
										<path d="M17,19.8 C11.9,19.8 7.7,15.4 7.7,10 C7.7,4.6 11.9,0.2 17,0.2 C22.1,0.2 26.3,4.6 26.3,10 C26.3,15.4 22.1,19.8 17,19.8 L17,19.8 Z M17,2.2 C13,2.2 9.7,5.7 9.7,10 C9.7,14.3 13,17.8 17,17.8 C21,17.8 24.3,14.3 24.3,10 C24.3,5.7 21,2.2 17,2.2 L17,2.2 Z"></path>
										<path d="M33,33 L1,33 C0.7,33 0.4,32.9 0.3,32.7 C0.2,32.5 0,32.2 0,31.9 C0.5,26.2 5,21.5 11.4,19.7 C11.7,19.6 11.9,19.7 12.2,19.8 C12.4,19.9 12.6,20.2 12.7,20.4 L14,26.4 L14.8,25.2 L14.2,24.1 C14,23.7 14.1,23.2 14.4,22.8 L16.4,21.1 C16.8,20.8 17.3,20.8 17.7,21.1 L19.6,22.8 C19.9,23.1 20,23.6 19.8,24 L19.2,25.1 L20,26.4 L21.4,20.4 C21.5,20.1 21.6,19.9 21.9,19.8 C22.1,19.7 22.4,19.6 22.7,19.7 C29,21.6 33.5,26.4 34,31.9 C34,32.2 33.9,32.5 33.7,32.7 C33.5,32.9 33.3,33 33,33 L33,33 Z M2.2,31 L31.9,31 C31.1,27 27.7,23.6 23.1,22 L21.4,29.3 C21.3,29.7 21,30 20.6,30.1 C20.2,30.2 19.8,30 19.6,29.6 L17.2,25.8 C17,25.5 17,25.1 17.2,24.8 L17.7,23.9 L17,23.3 L16.3,23.9 L16.8,24.8 C17,25.1 17,25.5 16.8,25.8 L14.4,29.6 C14.2,29.9 13.8,30.1 13.4,30.1 C13,30 12.7,29.7 12.6,29.3 L11,22 C6.3,23.5 3,27 2.2,31 L2.2,31 Z"></path>
									</g>
								</g>
							</g>
						</g>
					</svg>
				}
				link={`/manager/agent/${props.object.agentID}/`}
				exist={(props.object && props.object.agentID)}
				text={(props.object && props.object.agentID && props.agents[props.object.agentID])?props.agents[props.object.agentID].firstName:""}
				hintText={<span>Enter agent name</span>}
				searchText={
					(props.object.agentID&&props.agents[props.object.agentID])?
						props.agents[props.object.agentID].firstName
						: ''
				}
				dataSource={
					R.map(agent => ({
						text: `${agent.firstName}`
					  , value: (
							<MenuItem
								key={agent._id}
								primaryText={agent.firstName}
							/>
						)
					  , id: agent._id
				  }), sortSev(props.agents, "firstName", "lastName"))
				}
				onChange={(obj)=>{
						// if(props.object.ownerID && props.object.ownerID != obj.id){
						// 	props.STAGE({
						// 		_id: props.object.ownerID
						// 	  , properties:
						// 	  (
						// 		  props.owners[props.object.ownerID].properties
						// 		  && props.owners[props.object.ownerID].properties.length
						// 	  )?
						// 	  R.reject(property => property == props.objectID, props.owners[props.object.ownerID].properties)
						// 	  : []
						// 		})
						// }
						obj = obj || {}
						props.STAGE({
							_id: props.objectID
						  , agentID: obj.id
						})
						// if(props.owners[obj.id].properties&&!props.owners[obj.id].properties.length){
						// 	props.STAGE({
						// 			_id: obj.id
						// 		, properties: [props.objectID]
						// 	})
						// }
						// if(props.owners[obj.id].properties&&props.owners[obj.id].properties.length&&!R.contains(props.objectID, props.owners[obj.id].properties)){
						// 	props.STAGE({
						// 			_id: obj.id
						// 		, properties:
						// 		(
						// 			props.owners[obj.id].properties
						// 			&& props.owners[obj.id].properties.length
						// 		)?
						// 		[...props.owners[obj.id].properties, props.objectID]
						// 		: [props.objectID]
						// 	})
						// }
					}
				}
				// DELETE={()=>{
				// 	props.STAGE({
				// 		_id: props.object._id
				// 	  , agentID: ""
				// 	})
				// }}
			/>
		)
	}
}

export default connect(select, dataActions)(AgentCombobox)



// WEBPACK FOOTER //
// ./src/components/AgentCombobox.js